import {useRoot} from '../Root/hooks';

export default (workerId: string) => {
  const {workerStateRegistry} = useRoot();
  return workerStateRegistry.states.get(workerId)?.state;
};
